import {ImbalanceItem, MonthOption} from "./types";

export function adjUnits(item: ImbalanceItem): number {
    return Math.abs(item.persistentImbalance);
}

export function skuKey(item: ImbalanceItem): string {
    return `${item.material}_${item.size}_${item.coo}_${item.quality}`;
}

export function generateMonthOptions(): MonthOption[] {
    const now = new Date();
    const opts: MonthOption[] = [];
    for (let i = 0; i < 6; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        opts.push({
            label: d.toLocaleDateString('en-GB', {month: 'short', year: 'numeric'}),
            value: `${yyyy}-${mm}`,
            threshold: i + 1,
        });
    }
    return opts;
}
